import React from 'react'
import { Col, Form, Row } from 'antd'
import DocumentUpload from "../../../helpers/DocumentsUpload";

function DocumentPicture() {

	return (
		<Row>
			<Col xs={24} md={12} xl={8}>
				<Form.Item
					name={['metadata', 'idCard', 'document', 'front']}
					label={'Лична карта (лице)'}
					className='input-box'
					valuePropName={'document'}
				>
					<DocumentUpload />
				</Form.Item>
			</Col>
			<Col xs={24} md={12} xl={8}>
				<Form.Item
					name={['metadata', 'idCard', 'document', 'back']}
					label={'Лична карта (гръб)'}
					className='input-box'
					valuePropName={'document'}
				>
					<DocumentUpload />
				</Form.Item>
			</Col>
			<Col xs={24} md={12} xl={8}>
				<Form.Item
					name={['metadata', 'idCard', 'document', 'certificate']}
					label={'Свидетелство за съдимост'}
					className='input-box'
					valuePropName={'document'}
				>
					<DocumentUpload />
				</Form.Item>
			</Col>
		</Row>
	)
}

export default DocumentPicture
